import axios from "axios";
import { EPMS_API_BASE_URL as baseUrlArr } from "../configuration";
import { BASE_URL } from "../common/constants/baseUrls";

const currentDomain = window.location.hostname;
const domainConfig = baseUrlArr && baseUrlArr.length > 0 && baseUrlArr.find((e) => currentDomain === e.key);

if (domainConfig) {
  axios.defaults.baseURL = domainConfig.baseUrl;
} else {
  axios.defaults.baseURL = BASE_URL;
}

export default axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "json",
});
